import { useEffect, useState } from "react";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { LuFacebook, LuMessageCircle } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import { getFirestore, collection, doc, query, where, orderBy, onSnapshot, getDoc } from "firebase/firestore";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import { companyData, privacySections as sections } from "../data/privacyPolicy";

function PrivacyModal({ open, onClose }) {
    const [activeSection, setActiveSection] = useState("intro");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (open) {
            setTimeout(() => setVisible(true), 10);
        } else {
            setVisible(false);
        }
    }, [open]);

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => onClose(), 300);
    };

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-0 md:p-4"
            style={{
                background: `rgba(0,0,0,${visible ? "0.6" : "0"})`,
                transition: "background 0.3s ease",
                backdropFilter: visible ? "blur(4px)" : "blur(0px)",
            }}
            onClick={handleClose}
        >
            <div
                className="relative w-full md:max-w-3xl md:rounded-2xl overflow-hidden flex flex-col"
                style={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    maxHeight: "90vh",
                    transform: visible ? "translateY(0)" : "translateY(40px)",
                    opacity: visible ? 1 : 0,
                    transition: "transform 0.35s cubic-bezier(0.16,1,0.3,1), opacity 0.3s ease",
                    boxShadow: "0 40px 80px rgba(0,0,0,0.2)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start justify-between px-6 py-5 flex-shrink-0 border-b border-gray-100">
                    <div>
                        <div className="text-xs tracking-widest uppercase mb-1 text-orange-600 font-semibold">
                            {companyData.name}
                        </div>
                        <h2 className="text-xl font-bold text-gray-900">
                            Política de Privacidade
                        </h2>
                        <p className="text-xs mt-1 text-gray-400">
                            Última atualização: março de 2026 · Em conformidade com a LGPD
                        </p>
                    </div>
                    <button
                        onClick={handleClose}
                        className="flex-shrink-0 mt-1 ml-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-900 transition-all duration-200"
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>

                <div className="flex flex-1 overflow-hidden">
                    <nav className="hidden md:flex flex-col gap-0.5 p-4 flex-shrink-0 overflow-y-auto bg-gray-50 border-r border-gray-100" style={{ width: "210px" }}>
                        {sections.map((s) => (
                            <button
                                key={s.id}
                                onClick={() => setActiveSection(s.id)}
                                className="text-left px-3 py-2 rounded-lg text-xs transition-all duration-150"
                                style={{
                                    color: activeSection === s.id ? "#111" : "#9ca3af",
                                    background: activeSection === s.id ? "#fff" : "transparent",
                                    borderLeft: activeSection === s.id ? "2px solid #dc2626" : "2px solid transparent",
                                    fontWeight: activeSection === s.id ? 600 : 400,
                                    boxShadow: activeSection === s.id ? "0 1px 4px rgba(0,0,0,0.06)" : "none",
                                }}
                            >
                                {s.title}
                            </button>
                        ))}
                    </nav>

                    <div className="flex-1 overflow-y-auto p-6">
                        <div className="md:hidden space-y-6">
                            {sections.map((s) => (
                                <div key={s.id}>
                                    <h3 className="text-sm font-semibold mb-2 text-orange-600 uppercase tracking-wider">
                                        {s.title}
                                    </h3>
                                    <p className="text-sm leading-relaxed whitespace-pre-line text-gray-600">
                                        {s.content}
                                    </p>
                                </div>
                            ))}
                        </div>

                        {sections
                            .filter((s) => s.id === activeSection)
                            .map((s) => (
                                <div key={s.id} className="hidden md:block">
                                    <h3 className="text-base font-bold mb-1 text-gray-900">
                                        {s.title}
                                    </h3>
                                    <div className="mb-4 w-10 h-0.5 bg-orange-600" />
                                    <p className="text-sm leading-7 whitespace-pre-line text-gray-600">
                                        {s.content}
                                    </p>
                                </div>
                            ))}
                    </div>
                </div>

                <div className="flex items-center justify-between px-6 py-4 flex-shrink-0 border-t border-gray-100 bg-gray-50">
                    <div className="text-xs text-gray-400">
                        Dúvidas?{" "}
                        <a href={`mailto:${companyData.email}`} className="text-orange-600 hover:underline">
                            {companyData.email}
                        </a>
                    </div>
                    <button
                        onClick={handleClose}
                        className="px-4 py-2 rounded-lg text-xs font-semibold bg-orange-600 hover:bg-orange-700 text-white transition-all duration-200"
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function Footer() {
    const [revenda, setRevenda] = useState({});
    const [privacyOpen, setPrivacyOpen] = useState(false);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
        const firestore = getFirestore(app);

        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setRevenda(docSnap.data());
            }
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
        });

        return () => unsubscribe();
    }, []);

    return (
        <>
            <footer className="relative bg-black text-white overflow-hidden">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-px bg-gradient-to-r from-transparent via-orange-600/60 to-transparent" />

                <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-12">
                    <div>
                        <img
                            src="/logo-white.png"
                            alt="HG MULTIMARCAS"
                            className="w-48 mb-4"
                        />

                        <p className="text-sm text-white/70 max-w-sm mb-6">
                            Sua loja de confiança para adquirir veículos de qualidade com um atendimento excepcional e preços competitivos!
                        </p>

                        <div className="flex gap-4 text-xl text-white">
                            <a className="hover:text-orange-500 transition" href={revenda.facebook_link}>
                                <LuFacebook />
                            </a>
                            <a className="hover:text-orange-500 transition" href={revenda.instagram_link}>
                                <FaInstagram />
                            </a>
                            <a
                                className="hover:text-orange-500 transition"
                                href={`https://api.whatsapp.com/send?phone=55${retiraMascara(revenda.petelefone2, "link")}`}
                            >
                                <LuMessageCircle />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6 relative">
                            Links rápidos
                            <span className="block w-8 h-[2px] bg-orange-600 mt-2" />
                        </h3>

                        <ul className="space-y-3 text-sm text-white/70">
                            {navLinks.map(link => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        className="hover:text-white transition"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a href="/politica-de-privacidade" className="hover:text-white transition">
                                    Política de Privacidade
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-6 relative">
                            Contato
                            <span className="block w-8 h-[2px] bg-orange-600 mt-2" />
                        </h3>

                        <div className="space-y-4 text-sm text-white/70">
                            <div className="flex gap-3">
                                <FaLocationDot className="text-orange-600 mt-1" />
                                <p>
                                    {revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} - {revenda.pebairro_fiscal}, {revenda.pecidade} - {revenda.peuf}
                                </p>
                            </div>

                            <div className="flex gap-3 items-center">
                                <FaPhoneAlt className="text-orange-600" />
                                <span>{retiraMascara(revenda.petelefone1)}</span>
                            </div>

                            <div className="flex gap-3 items-center">
                                <LuMessageCircle className="text-orange-600" />
                                <span>{retiraMascara(revenda.petelefone2)}</span>
                            </div>

                            <div className="flex gap-3 items-center">
                                <MdOutlineEmail className="text-orange-600" />
                                <span>{revenda.peemail}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/10 py-4 text-center text-xs text-white/60">
                    © 2026 HG Multimarcas. Todos os direitos reservados.
                    <a
                        className="ml-2 hover:text-white transition text-orange-600 font-semibold"
                        href="https://intermedioveiculos.com.br/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Intermédio Veículos Marketing Digital
                    </a>
                    <span className="mx-2 text-white/30">·</span>
                    <a
                        href="/politica-de-privacidade"
                        className="hover:text-white transition text-white/60 underline underline-offset-2"
                    >
                        Política de Privacidade
                    </a>
                </div>
            </footer>

            <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
        </>
    );
}
